

































export default  {

  data () {
    return {

    }
  },
  mounted() {
    this.$store.state.headerTitle = "Updates"
  
  },

  methods: {
   
  },

}
